// extracted by mini-css-extract-plugin
export default {"card":"ImageCard_card__mBU8P"};